import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class ModelPresenter extends EntityPresenter {
  static urn = 'models'

  static navOptions(key = 'models') {
    const routes = {
      models: {
        icon: 'notifications',
        pageRoutes: ['model'],
      },
    }
    return routes[key]
  }
}

bindPresenterMethods(ModelPresenter)
